import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { eosTool } from '@/services/blockchain/eos-tool'
import type { EosAccount, WalletSession, WalletType } from '@/types'

interface WalletState {
  session: WalletSession | null
  isLogin: boolean
  connect: (wallet: WalletType) => Promise<EosAccount | null>
  login: (wallet: WalletType) => Promise<EosAccount | null>
  logout: () => Promise<void>
  setSession: (session: WalletSession | null) => void
}

export const useWalletStore = create<WalletState>()(
  persist(
    (set, get) => ({
      session: null,
      isLogin: false,
      connect: async (wallet) => {
        const account = await eosTool.connect(wallet)
        if (account) {
          set({ session: { wallet, account }, isLogin: true })
        }
        return account
      },
      login: async (wallet) => {
        const account = await eosTool.login(wallet)
        if (account) {
          set({ session: { wallet, account }, isLogin: true })
        }
        return account
      },
      logout: async () => {
        await eosTool.logout()
        set({ session: null, isLogin: false })
      },
      setSession: (session) => {
        set({ session, isLogin: !!session?.account })
      },
    }),
    {
      name: 'totoro-wallet',
      partialize: (state) => ({ session: state.session }),
    },
  ),
)
